import { VoidComponent } from "solid-js";

export const OneSysFooter: VoidComponent = () => {
	return (
		<footer
			class="p-4 footer footer-bottom container-fluid"
			style="z-index: 1;">
			<div class="d-flex flex-column justify-content-center align-items-center">
				<img
					src="/logo.jpg"
					alt="logo"
					width="90"
					height="30"
					class="mb-4">
				</img>
				<p class="text-center font-small">
					<a
						target="_blank"
						href="https://www.google.com/maps/place/%CE%9A%CE%B1%CF%81%CF%8C%CF%81%CE%B7+23,+%CE%91%CE%B8%CE%AE%CE%BD%CE%B1+105+51/@37.9781851,23.7278375,17z/data=!3m1!4b1!4m5!3m4!1s0x14a1bd3cadbe7877:0xde8859421fb3012b!8m2!3d37.9781851!4d23.7278375"
						class="footer-link"
					>
						Aiolou & Karori 23
					</a>, 
					10551, 
					Athens 
					<a
						href="tel:2103003330"
						class="footer-link">
						Tel: +30 210 3003330 
					</a> 
					© Copyright - OneSys IT Solutions 
					<a
						target="_blank"
						href="https://onesys.gr/wp-content/uploads/2022/01/OneSys-IT-Solutions_ISO_HLD_QISP_Quality-and-Information-Security-Policy_EN_V1.0_030122.pdf"
						class="footer-link">
						- Quality and Information Security Policy
					</a>
				</p>
			</div>
		</footer>
	);
};